import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4093b74e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "call-grid"
}
const _hoisted_2 = { class: "nine-one-one container" }
const _hoisted_3 = { class: "non-nine-one-one container" }

import { storeToRefs } from 'pinia';
    import { CallDetails } from '..';
    import { useRoot } from '../../stores/root';
    import { useAuth } from '../../stores/auth';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Columns',
  setup(__props) {

    // import { watch } from 'vue';
    const rootState = useRoot();
    const authState = useAuth();

    const {
        // getAlertStatus, 
        getSelectedSiteEmergencyData, 
        getSelectedSiteNonEmergencyData 
    } = storeToRefs(rootState);

    const { getAuthStatus } = storeToRefs(authState);

    // const audio = new Audio('Small-Bell.mp3');
    // const alert = () => {
    //     audio.play();
    //     rootState.playAlertBell = false;
    // };

    // Will this cause sound to ding even on other sites?
    // I think it will, I may need to have a separation of alerts
    // watch(getAlertStatus, () => alert());


return (_ctx: any,_cache: any) => {
  return (_unref(getAuthStatus))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectedSiteEmergencyData).slice(0, 10), (call, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_unref(CallDetails), {
                callData: call,
                emergency: true
              }, null, 8, ["callData"])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectedSiteNonEmergencyData).slice(0, 10), (call, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createVNode(_unref(CallDetails), {
                callData: call,
                emergency: false
              }, null, 8, ["callData"])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})